//系统识别
function system_confirm(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}};function device_confirm(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;};
if(system_confirm()=="mac"&&device_confirm()){var isMac=true}
else if(system_confirm()=="win"&&device_confirm()){var isMac=false}
if(device_confirm()==true){var device_id=true}
else if(device_confirm()==false){var device_id=false}else{};
function system_fn(){
    if (isMac == true) {
      $('.mac_btn_box').css({"display": "-webkit-box","display":"-webkit-flex","display":"flex"});
      $('.mac_btn').css({"display":"block"});
      $('.mac_inline').css({"display":"inline-block"});
      $('.win_inline').css({"display":"none"});
      $('.win_btn_box').css({"display":"none"});
      $('.win_btn').css({"display":"none"});
    } else if (!isMac == true) {
      $('.win_btn_box').css({"display": "-webkit-box","display":"-webkit-flex","display":"flex"});
      $('.win_btn').css({"display":"block"});
      $('.mac_inline').css({"display":"none"});
      $('.win_inline').css({"display":"inline-block"});
      $('.mac_btn_box').css({"display":"none"});
      $('.mac_btn').css({"display":"none"});
      
    } else if (device_id == false) {
      $('.pc_btn').css({"display":"none"});
      $('.mac_inline').css({"display":"none"});
      $('.win_inline').css({"display":"inline-block"});
    };
};
system_fn();
function detectDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    
    // 检测是否为 iOS 设备
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    
    // 检测是否为 Android 设备
    const isAndroid = /android/.test(userAgent);
    
    if (isIOS) {
      return 'iOS';
    } else if (isAndroid) {
      return 'Android';
    } else {
      return '其他设备';
    }
}

// 使用示例
const deviceType = detectDevice();

// 根据设备类型执行不同操作
if (deviceType === 'iOS') {
    // iOS 特定代码
} else if (deviceType === 'Android') {
    // Android 特定代码
}

// 判断下导航app按钮是否显示
if(device_confirm()==false){
    if(system_confirm()=='mac'){
        $('.footer .mobile_btn .google').hide();
    }else{
        $('.footer .mobile_btn .store').hide();
    }
}

$('.footer dl dt').on('click',function(){
    $(this).toggleClass('active');
});

// header
function headerResize(){
    resizeClearStyle();
    if($(window).width()>768){
        $('.header_bg').hide();
        $('.header .header_box .header_box_nav,.header .header_box .header_box_nav ul,.header .accoutn_box').removeAttr('style')
        $('.header .toggle').removeClass('active');
    }else{
        if($('.header .login_btn .user_info').css('display') == 'block'){
            $('.header .login_btn .user_info').show()
        }else{
            $('.header .login_btn .user_info').hide()
        }
        $('.header .login_btn .user_info').css({
            'width':$(window).width() + 'px',
            "transform":'translateX('+ 20 + 'px)',
        });
    }
}
headerResize()
var windowWidth=$(window).width();
$(window).resize(function(){
    if(windowWidth!=$(window).width()){
        headerResize()
        windowWidth=$(window).width()
    }
});



$('.header .header_nav li.menu_lists').hover(function(){
    if($(window).width() > 1200){
        $(this).addClass('active').siblings().removeClass('active')
    }
},function(){
    if($(window).width() > 1200){
        $(this).removeClass('active')
    }
});    
$('.header .header_box_nav li.menu_lists').click(function(){
    if($(window).width()<=1200){
        $(this).toggleClass('active').siblings().removeClass('active')
    }
})
$('.header .toggle').click(function(){
    $(this).toggleClass('active')
    $('.header_box_nav').toggleClass('active');
    if($(this).hasClass('active')){
        $('.header_bg').show();
        $('.header_box_nav').show()
        $('.header .login_btn .user_info').hide();
    }else{
        $('.header_bg').hide();
        $('.header_box_nav').hide()
        $('.header .header_nav>li.menu_lists').removeClass('active');
    }
})
$('.header_bg').click(function(){
    $(this).hide();
    $('.header_box_nav').hide()
    $('.header .header_box_nav ul').hide()
    $('.header .toggle').removeClass('active')
    $('.header_box_nav').removeClass('active')
    $('.header .accoutn_box').removeClass('active');
    $('.header .login_btn .user_info').removeAttr('style');
    $('.header .header_nav>li.menu_lists').removeClass('active');
    if(user){
        $('.header .login_btn').addClass('active')
    }else{
        $('.header .login_btn').removeClass('active')
    }
});

document.addEventListener('click',function(){
    $('.header .login_btn .user_info').hide();
});

$('.header .login_btn .user_info').click(function(){
    $(this).hide();
    $('.header_bg').hide();
})

const loginBox = $('.header .login_btn .login_box')[0];
if (loginBox) {
    try {
        loginBox.addEventListener('click', function(event) {
            event.stopPropagation();
            if($(window).width()<=1200){
                $('.header .login_btn .login_box').off('mouseover');
                $('.header .login_btn .login_box').off('mouseout');
                if(user){
                    if($(window).width() > 768){
                        $('.header_bg').hide();
                    }else{
                        $('.header .login_btn .user_info').css({
                            'width':$(window).width() + 'px',
                            "transform":'translateX('+ 20 + 'px)',
                        });
                        $('.header_bg').show();
                    }
                    if($('.header .toggle').hasClass('active')){
                        $('.header .toggle').removeClass('active')
                        $('.header .login_btn .user_info').show();
                        $('.header .header_box_nav ul').hide()
                    }else{
                        if($('.header .login_btn .user_info').css('display') == 'block'){
                            $('.header .login_btn .user_info').hide();
                        }else{
                            $('.header .login_btn .user_info').show();
                        }
                    }
                }
                if(!user){
                    $('.header_bg').hide();
                }
            }
        });
    } catch (error) {
        console.error(error);
    }
}

// 每次横向拖动窗口把样式清掉
function resizeClearStyle(){
    $('.header .login_box ul').removeClass('active')
    if($(window).width() > 768){
        $('.header .login_btn .user_info').removeAttr('style');
        $('.header .header_box_nav').removeClass('active')
    }
}

var HtmlUtil = {
    /*1.用浏览器内部转换器实现html转码*/
    htmlEncode:function (html){
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement ("div");
        //2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)
        (temp.textContent != undefined ) ? (temp.textContent = html) : (temp.innerText = html);
        //3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
        var output = temp.innerHTML;
           temp = null;
           return output;
    },
    /*2.用浏览器内部转换器实现html解码*/
    htmlDecode:function (text){
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
        temp.innerHTML = text;
        //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
        var output = temp.innerText || temp.textContent;
        temp = null;
        return output;
    }
};
/**
 * 用于同步google登录状态
 * @param {*} pathname 域名
 */
function googleSyncInfo(hostname){
    if(hostname=='www.vidhex.ai'){
        google_client_id = '1077061664751-39uhc1387spdotlls3955q7h9afrpn1c.apps.googleusercontent.com'
    }else{
        google_client_id = '1077061664751-39uhc1387spdotlls3955q7h9afrpn1c.apps.googleusercontent.com'
    }
    $('body').append('<div id="g_id_onload" data-client_id="'+google_client_id+'" data-context="signin" data-callback="haedcallback" data-auto_select="true" data-close_on_tap_outside="false" data-itp_support="true"></div>');
    var google_script=document.createElement('script'); 
    google_script.src="https://accounts.google.com/gsi/client"; 
    google_script.async=true;
    $('body').append(google_script)
}
window.haedcallback = function(response){
    window.setCookie('user_google', JSON.stringify({ 'google_id_token': response.credential }), 90);
    window.setCookie('google_id_token', JSON.stringify({ 'google_id_token': response.credential }), 90);
    google_login();
}

let domain=".vidhex.ai";

function setCookie(name,value,iDay){      //name相当于键，value相当于值，iDay为要设置的过期时间（天）
    var oDate = new Date();
    oDate.setDate(oDate.getDate() + iDay);
    document.cookie = name + '=' + value + ';path=/;domain='+domain+';expires=' + oDate;
    // document.cookie = name + '=' + value + ';path=/;expires=' + oDate;
}

//获取cookie
function getCookie(name) {
    var prefix = name + "="
    var start = document.cookie.indexOf(prefix)
 
    if (start == -1) {
        return null;
    }
 
    var end = document.cookie.indexOf(";", start + prefix.length)
    if (end == -1) {
        end = document.cookie.length;
    }
 
    var value = document.cookie.substring(start + prefix.length, end)
    return unescape(value);
}

//公共区域位置打点
$(document).click(function (e) {
    try {
        if (e.target.getAttribute('data-operation') || e.target.getAttribute('data-label')) {
            manage(e.target.getAttribute('data-operation'), e.target.getAttribute('data-label'))
        }
    } catch (e) { }
});
function manage(operation, data) {
    try {
        dataLayer.push({
            'event':'online',
            'name': 'www',
            'operation': operation,
            'lable': String(data)
        });
    } catch (e) {
        console.log(e);
    }
};
// 订阅
var reg_email = /^[a-zA-Z0-9.!#$%&amp;*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const email_number = $('.email .email_number');
const subscribeBtn = $('.footer .subscribe_btn');
const emailParent = $('.email');

// 检查元素是否存在
if (email_number.length && subscribeBtn.length && emailParent.length) {
    email_number.add(subscribeBtn).on({
        focus: function() {
            emailParent.addClass('active');
        },
        blur: function() {
            emailParent.removeClass('active');
        }
    });

    subscribeBtn.click(function(){
        if(reg_email.test(email_number.val())){
            $.ajax({
                url:'https://www.vidhex.ai/api/subscribe.php',
                method:"post",
                dataType:"json",
                data:{
                    'email':email_number.val(),
                    'link':'https://www.vidhex.ai'+location.pathname,
                    'source':'footer',
                },
                success: function(res){
                    console.log(res);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error('请求失败:', textStatus, errorThrown);
                }
            });
            email_number.val('')
            const formSuccess = $('.form_success');
            if (formSuccess.length) {
                $('.form_success .title').text('Congratulations!');
                $('.form_success .info').text(`Thank you for subscribing! You've successfully joined our newsletter. Expect updates, offers, and insights delivered straight to your inbox.`);
                formSuccess.show()
            }
            const errorTipP = $('.error_tip p');
            if (errorTipP.length) {
                errorTipP.hide()
            }
        } else {
            if(email_number.val() === ''){
                const errorTipP = $('.error_tip p');
                if (errorTipP.length) {
                    errorTipP.hide()
                }
                const errorEmpty = $('.error_tip .error_empty');
                if (errorEmpty.length) {
                    errorEmpty.show() 
                }
            } else if(!reg_email.test(email_number.val())){
                const errorTipP = $('.error_tip p');
                if (errorTipP.length) {
                    errorTipP.hide()
                }
                const errorWrong = $('.error_tip .error_wrong');
                if (errorWrong.length) {
                    errorWrong.show()
                }
            }
        }
    })
}

const couponTextI = $('.coupon_text i');
if (couponTextI.length) {
    couponTextI.on('click', function() {
        const textToCopy = $(this).parent().text().trim();
        const temp = $('<textarea>');
        $('body').append(temp);
        temp.val(textToCopy).select();
        navigator.clipboard.writeText(textToCopy).then(() => {
            const successCopy = $('.success_copy');
            if (successCopy.length) {
                successCopy.show();
                setTimeout(() => {
                    successCopy.fadeOut();
                }, 2000);
            }
        })
        temp.remove();
    });
}

// 关闭
const formSuccessClose = $('.form_success>div .close');
if (formSuccessClose.length) {
    formSuccessClose.click(function(){
        const formSuccess = $('.form_success');
        if (formSuccess.length) {
            formSuccess.hide()
        }
    })
}

const formSubmitClose = $('.form_submit>div .close');
if (formSubmitClose.length) {
    formSubmitClose.click(function(){
        const formSubmit = $('.form_submit');
        if (formSubmit.length) {
            formSubmit.hide()
        }
    })
}
